if(!window.__storeforgeRuntime){window.__storeforgeRuntime=true;
document.documentElement.classList.remove('no-js');
document.addEventListener('click',function(event){
  const quantityButton=event.target.closest('[data-sf-quantity-change]');
  if(quantityButton){const group=quantityButton.closest('[data-sf-quantity]');const input=group?.querySelector('input[type="number"]');if(input){const minimum=Number(input.min||0);const maximum=input.max?Number(input.max):Number.MAX_SAFE_INTEGER;const next=Math.min(maximum,Math.max(minimum,Number(input.value||minimum)+Number(quantityButton.dataset.sfQuantityChange||0)));input.value=String(next);input.dispatchEvent(new Event('change',{bubbles:true}));}return;}
  const open=event.target.closest('[data-sf-menu-toggle]');
  const close=event.target.closest('[data-sf-menu-close]');
  if(open){document.body.classList.add('sf-menu-open');document.querySelector('.sf-mobile-menu__panel')?.focus();}
  if(close){document.body.classList.remove('sf-menu-open');}
});
document.addEventListener('keydown',function(event){if(event.key==='Escape')document.body.classList.remove('sf-menu-open');});
document.addEventListener('change',function(event){
  const select=event.target.closest('[data-sf-variant-select]');
  if(!select)return;
  const option=select.options[select.selectedIndex];
  const root=select.closest('[data-sf-product-root]');
  const button=root?.querySelector('.sf-product-submit');
  if(button){button.disabled=option.disabled;button.textContent=option.disabled?'Sold out':'Add to cart';}
});
const hydrateHeroFallbacks=function(root){
  const scope=root||document;
  scope.querySelectorAll('.sf-hero-media[data-sf-fallback-src]').forEach(function(picture){
    const image=picture.querySelector('img');
    if(!image||image.dataset.sfFallbackBound==='true')return;
    image.dataset.sfFallbackBound='true';
    image.addEventListener('error',function(){
      const fallback=picture.dataset.sfFallbackSrc;
      if(!fallback||image.dataset.sfFallbackUsed==='true')return;
      image.dataset.sfFallbackUsed='true';
      picture.querySelectorAll('source').forEach(function(source){source.remove();});
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src=fallback;
    });
  });
};
const hydrateCategoryMedia=function(root){
  const scope=root||document;
  const productImages=Array.from(document.querySelectorAll('.sf-product-grid img')).filter(function(image){return image.currentSrc||image.src;});
  if(!productImages.length)return;
  scope.querySelectorAll('.sf-category-card__media').forEach(function(media,index){
    if(media.querySelector('img'))return;
    const source=productImages[index%productImages.length];
    const image=source.cloneNode(false);
    image.loading='eager';
    image.decoding='async';
    image.alt=media.closest('.sf-category-card')?.querySelector('span')?.textContent?.trim()||source.alt||'Collection';
    media.replaceChildren(image);
  });
};
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){hydrateHeroFallbacks(document);hydrateCategoryMedia(document);},{once:true});}else{hydrateHeroFallbacks(document);hydrateCategoryMedia(document);}
document.addEventListener('shopify:section:load',function(event){hydrateHeroFallbacks(event.target);hydrateCategoryMedia(event.target);event.target.dispatchEvent(new CustomEvent('storeforge:mount',{bubbles:true}));});
document.addEventListener('shopify:section:unload',function(event){event.target.dispatchEvent(new CustomEvent('storeforge:unmount',{bubbles:true}));});
document.addEventListener('storeforge:mount',function(event){event.target.querySelectorAll('[data-sf-autofocus]').forEach(function(node){node.removeAttribute('data-sf-autofocus');});});
}